var map = {
	"./CircleShape/Component": [
		2807,
		807
	],
	"./CtrlVButton/Component": [
		5515,
		515
	],
	"./Group/Component": [
		628,
		628
	],
	"./LineShape/Component": [
		1910,
		910
	],
	"./Picture/Component": [
		5110,
		110
	],
	"./RectShape/Component": [
		5350,
		350
	],
	"./StyleButton/Component": [
		1385,
		385
	],
	"./VButton/Component": [
		1897,
		897
	],
	"./VButtons/Component": [
		953,
		953
	],
	"./VFastButton/Component": [
		3439,
		439
	],
	"./VFastButtons/Component": [
		5086,
		86
	],
	"./VIframe/Component": [
		4496,
		496
	],
	"./VSelect/Component": [
		9346,
		346
	],
	"./VText/Component": [
		1715,
		715
	],
	"./VWebViewButton/Component": [
		1839,
		839
	],
	"./Vmatrix/Component": [
		7081,
		81
	],
	"./Vplayer/Component": [
		3573,
		573
	],
	"./Vrange/Component": [
		9336,
		336
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8832;
module.exports = webpackAsyncContext;